import { render, staticRenderFns } from "./message_history.vue?vue&type=template&id=6e7812fd"
import script from "./message_history.vue?vue&type=script&lang=ts"
export * from "./message_history.vue?vue&type=script&lang=ts"
import style0 from "./message_history.vue?vue&type=style&index=0&id=6e7812fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports